import { useQuery } from '@tanstack/react-query';

import Api from '@app/services/api';

export const useGetWarehouseSkusImportErrorCountQuery = (uid: string) => {
  return useQuery({
    queryKey: ['getWarehouseSkusImportErrorCount', uid],
    queryFn: () => Api.wms.getWarehouseSkusImportErrorCount(uid),
    enabled: !!uid,
  });
};
